import {networkError, uiInfo, uiSuccess} from "./ui";
import * as R from 'ramda';
import {
  createEmailProjectInvites$,
  createProject$,
  createProjectContactListInvites$,
  createProjectInvites$,
  deleteProject$,
  getProjectInviteById$,
  getProjectInvites$,
  getProjects$,
  getProjectsIndex$,
  leaveProject$,
  setProjectViewed$,
  updateProject$,
  updateProjectInvitePermissions$
} from "../services/projects";
import {addProjectContacts} from "./projectcontacts";
import {clearView, clearViewIndex, extractView, extractViewIndex, injectView, setViewCache, setViewIndex} from "./view";

export const ADD_PROJECTS = 'ADD_PROJECTS';
export const addProjects = (projects) => ({type: ADD_PROJECTS, payload: projects});
export const API_GET_PROJECTS_DONE = 'API_GET_PROJECTS_DONE';
export const getProjectsDone = (response) => ({type: API_GET_PROJECTS_DONE, payload: response});
export const API_GET_PROJECT = 'API_GET_PROJECT';
export const getProject = (id) => ({type: API_GET_PROJECT, payload: {id}});
export const API_GET_PROJECT_DONE = 'API_GET_PROJECT_DONE';
export const getProjectDone = (response, callback) => ({ type: API_GET_PROJECT_DONE, payload: { response, callback } });
export const REMOVE_PROJECT = 'REMOVE_PROJECT';
export const removeProject = (projectId) => ({ type: REMOVE_PROJECT, payload: { projectId } });

export const getProjectsIndex = ({ sortby, order, filterby, from, to, status, limit, search }) => async (dispatch, getState) => {
  try {
    let { response, status: response_status } = await getProjectsIndex$({
      sortby,
      order,
      filterby,
      from,
      to,
      status,
      limit,
      search
    }).toPromise();
    if (response_status === 204) {
      dispatch(clearViewIndex());
      return;
    }
    if (response === null) return;
    let { results } = response;
    if (results.length > 0) {
      dispatch(setViewIndex(results));
    }
  } catch (error) {
    dispatch(networkError({...error, number: '10115-'+error.status}));
  }
};

export const getProjects = ({ sortby, order, filterby, from, to, status, limit, search } = {}) => async (dispatch, getState) => {
  try {
    let soFar = 0;
    let theSize = 0;
    let nextOffset;
    let nextSortOffset;
    do {
      dispatch(setViewCache({loading: true}));
      let { response, status: response_status } = await getProjects$({
        offset: nextOffset,
        sortoffset: nextSortOffset,
        sortby,
        order,
        filterby,
        from,
        to,
        status,
        limit,
        search
      }).toPromise();
      if (response_status === 204) {
        dispatch(setViewCache({loading: false}));
        dispatch(clearView());
        return;
      }
      if (response === null) {
        dispatch(setViewCache({loading: false}));
        return;
      }
      let { results, offset, size } = response;
      theSize = size;
      soFar += results.length;
      if (results.length > 0) {
        dispatch(getProjectsDone({ results }));
        nextOffset = R.last(results).resource.id;
        if (sortby) nextSortOffset = R.last(results).resource[sortby];
      }
      dispatch(setViewCache({loading: false}));
    } while (soFar < (limit || theSize) && theSize > limit);
  } catch (error) {
    dispatch(setViewCache({loading: false}));
    dispatch(networkError({...error, number: '10060-'+error.status}));
  }
};

export const createProject = (project, callback) => async (dispatch, getState) => {
  try {
    let { response, status } = await createProject$({ project }).toPromise();
    ({ response, status } = await getProjects$({ id: response }).toPromise());
    dispatch(getProjectDone(response, callback));
  } catch (error) {
    dispatch(networkError({...error, number: '10116-'+error.status}));
  }
};

export const leaveProject = (projectId) => async (dispatch, getState) => {
  try {
    let { response, status } = await leaveProject$({ projectId }).toPromise();
    dispatch(removeProject(projectId));
    dispatch(extractView([projectId]));
    dispatch(extractViewIndex([projectId]));
  } catch (error) {
    dispatch(networkError({...error, number: '10117-'+error.status}));
  }
};

export const deleteProject = (projectId) => async (dispatch, getState) => {
  try {
    let { response, status } = await deleteProject$({ projectId }).toPromise();
    dispatch(removeProject(projectId));
    dispatch(extractView([projectId]));
    dispatch(extractViewIndex([projectId]));
  } catch (error) {
    dispatch(networkError({...error, number: '10118-'+error.status}));
  }
};

export const updateProject = (project) => async (dispatch, getState) => {
  try {
    let projectId = project.id;
    project = R.compose(
      R.dissoc('viewed')
    )(project);
    let { response, status } = await updateProject$({ projectId, project }).toPromise();
    let { response: response2, status: status2 } = await getProjects$({ id: projectId }).toPromise();
    dispatch(getProjectDone(response2));
  } catch (error) {
    dispatch(networkError({...error, number: '10119-'+error.status}));
  }
};

export const inviteUser = (projectId, userId) => async (dispatch, getState) => {
  try {
    let { response, status } = await createProjectInvites$({ projectId: projectId, inviteUserIds: [userId] }).toPromise();
    let invitedUser = response[0];
    ({ response, status } = await getProjectInviteById$({ projectId: projectId, userId: invitedUser }).toPromise());
    dispatch(addProjectContacts([response]));
  } catch (error) {
    dispatch(networkError({...error, number: '10120-'+error.status}));
  }
};

export const quickInviteUserEmailSingle = (projectId, inviteUserEmail) => async (dispatch, getState) => {
  try {
    dispatch(uiInfo('Sending invite to ' + inviteUserEmail));
    let { response } = await createEmailProjectInvites$({ projectId, inviteUserEmails: [inviteUserEmail] }).toPromise();
    ({ response } = await getProjectInvites$({ projectId: projectId, id: response }).toPromise());
    dispatch(addProjectContacts(response.results));
    dispatch(uiSuccess('Invited ' + inviteUserEmail + ' to project'));
  } catch (error) {
    dispatch(networkError({...error, number: '10121-'+error.status}));
  }
};

export const inviteUserEmails = (projectId, inviteUserEmails) => async (dispatch, getState) => {
  try {
    let { response } = await createEmailProjectInvites$({ projectId, inviteUserEmails }).toPromise();
    let groups = R.splitEvery(40, response);
    for (let group of groups) {
      ({ response } = await getProjectInvites$({ projectId: projectId, id: group }).toPromise());
      dispatch(addProjectContacts(response.results));
      dispatch(uiSuccess('Mass email invite sent'));
    }
  } catch (error) {
    dispatch(networkError({...error, number: '10122-'+error.status}));
  }
};

export const inviteUserContactLists = (projectId, contactListIds) => async (dispatch, getState) => {
  try {
    let {response} = await createProjectContactListInvites$({projectId, contactListIds}).toPromise();
    let groups = R.splitEvery(40, response);
    for (let group of groups) {
      ({ response } = await getProjectInvites$({ projectId: projectId, id: group }).toPromise());
      dispatch(addProjectContacts(response.results));
    }
  } catch (error) {
    dispatch(networkError({...error, number: '10123-'+error.status}));
  }
};

export const setProjectViewed = (projectId) => async (dispatch, getState) => {
  try {
    let { response } = await setProjectViewed$({ projectId }).toPromise();
  } catch (error) {
    dispatch(networkError({ ...error, number: '10156-' + error.status }));
  }
}

export const updateProjectInvitePermissions = (projectId, userId, role) => async (dispatch, getState) => {
  try {
    await updateProjectInvitePermissions$({ projectId, userId, role }).toPromise();
    let { response, status } = await getProjectInviteById$({ projectId, userId }).toPromise();
    dispatch(addProjectContacts([response]));
  } catch (error) {
    dispatch(networkError({...error, number: '10016-'+error.status}));
  }
};

export const injectProject = (id) => async (dispatch, getState) => {
  try {
    let { response, status } = await getProjects$({ id }).toPromise();
    if (!response || status === 404) return;
    dispatch(injectView([response]))
  } catch (error) {
    dispatch(networkError({...error, number: '10146-'+error.status}));
  }
};




// WEBPACK FOOTER //
// ./src/actions/projects.js